<div class="modal-confirm" data-cy="modal-confirm" [ngStyle]="{'width.px': setWidth()}">
  <!-- FIXME: CTWILS-2360 - check how the ExistingFileModalComponent handles the class here -->
  <div [ngClass]="{'modal-header': true, 'modal-header-error': isError(), 'modal-header-warning': isWarning(), 'modal-header-information': isInfo()}">
    <p class="modal-title" data-cy="modal-confirm-title">{{titleText}}</p>
    @if (hasCloseButton) {
      <button data-cy="modal-confirm-close-button" type="button" class="close"
      (click)="activeModal.dismiss()"></button>
    }
  </div>

  <div class="modal-body">
    <div class="modal-confirm-subtitle" data-cy="modal-manual-subtitle">{{subtitleText}}</div>
    @if (hasDetails()) {
      <section class="modal-confirm-details" data-cy="modal-confirm-details">
        <p>Details:</p>
        <ul>
          @for (detail of details; track detail) {
            <li data-cy="detail">{{detail}}</li>
          }
        </ul>
      </section>
    }
    @if (hasFooter()) {
      <br/>
      <strong  class="modal-confirm-footer" data-cy="modal-manual-footer">{{footer}}</strong>
    }
    @if (showManualInputs()) {
      <section class="modal-checks-section">
        <div class="modal-checks-title" [innerHTML]="manualChecks.title"
        data-cy="modal-manual-checks-title"></div>
        @for (manualCheck of manualChecks.inputs; track manualCheck; let index = $index) {
          <ng-container class="modal-checks">
            <div class="modal-checks">
              <input type="checkbox" [checked]="manualCheck.checked"
                data-cy="modal-manual-manual-check-input"
                class="modal-manual-check"
                (change)="toggleManualCheck(manualCheck)"
                id="manual-check-{{index}}">
              <label class="{{applyLabelClass(manualCheck)}}"
                data-cy="modal-manual-manual-check-label"
                for="manual-check-{{index}}"
              [textContent]="manualCheck.message"></label>
            </div>
          </ng-container>
        }
      </section>
    }
  </div>

  <div class="modal-footer">
    @if (secondaryButtonText || false) {
      <button type="button"
        class="btn-secondary"
        (click)="clickSecondaryButton()"
      data-cy="modal-secondary-button">{{secondaryButtonText}}</button>
    }
    @if (primaryButtonText || false) {
      <button type="button"
        class="{{getPrimaryButtonClass()}}"
        [disabled]="disablePrimaryButton()"
        (click)="clickPrimaryButton()"
      data-cy="modal-primary-button">{{primaryButtonText}}</button>
    }
  </div>
</div>
